import Label from "../../shapes/overlays/label";
import {getShapeFeatureId} from "../../../../../helpers/featureHelper";

const SHAPE_LABELS = ['center_island_countertop', 'countertop'];
export const updateShape = (partId, shape, wizardGroup = null) => {
  if (!shape) {
    return;
  }

  shape.setPartId(partId);
  shape.setFeatureId(getShapeFeatureId(partId));
  if (!SHAPE_LABELS.includes(partId)) {
    shape.setType(partId);
  } else {
    shape.setType(undefined);
  }
  if (wizardGroup) {
    shape.setProperty("fromWizardGroupId", wizardGroup.id);
  }
};

export const initLabel = (labelText, partId, shape) => {
  if (!shape || !shape.getLines || !shape.getLines()[0]) {
    return;
  }

  let firstShapeLine = shape.getLines()[0];

  if (firstShapeLine.labelOverlay) {
    firstShapeLine.labelOverlay.setLabelText(labelText);
  } else {
    firstShapeLine.labelOverlay = new Label();
    firstShapeLine.labelOverlay.init(firstShapeLine, labelText, partId);
  }
};

export const initTitle = (labelText, partId, shape) => {
  let thirdShapeLine = shape.getLines()[2];
  if (thirdShapeLine?.titleOverlay?.destroy) {
    thirdShapeLine.titleOverlay.destroy();
  }
  if (thirdShapeLine) {
    thirdShapeLine.titleOverlay = new Label({
      labelTextColor: 'rgba(165, 174, 183, 0.66)',
      isTitle: true,
      lineOffset: 20
    });
    thirdShapeLine.titleOverlay.init(thirdShapeLine, labelText, partId);
  }
};
